import toast from "react-hot-toast";

export function getInvoiceUrl(attachmentUrl) {
  if (!attachmentUrl || attachmentUrl === "null" || attachmentUrl === "undefined") {
    return null;
  }
  return attachmentUrl;
}

export function viewInvoice(attachmentUrl) {
  const url = getInvoiceUrl(attachmentUrl);
  if (!url) {
    toast.error("Invoice PDF is not available.");
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
}

export function printInvoice(attachmentUrl) {
  const url = getInvoiceUrl(attachmentUrl);
  if (!url) {
    toast.error("Invoice PDF is not available.");
    return;
  }

  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "none";
  iframe.src = url;
  document.body.appendChild(iframe);

  iframe.onload = () => {
    try {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } catch {
      window.open(url, "_blank", "noopener,noreferrer");
      toast.error("Could not open print dialog. Invoice opened in a new tab.");
    }
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000);
  };
}
